export const wheelConstants = {
  LOAD: "WHEEL_STATUS_LOAD",
  LOADING: "WHEEL_STATUS_LOADING",
  LOADED: "WHEEL_STATUS_LOADED",
};

